import { loadNg1Module, ngmodule } from "../../bootstrap/ngmodule";
import { customerShiftComponent } from "./shift.component";
import { customerShiftCalendarComponent } from "./shift.calendar.component";
import { customerShiftState, customerShiftCalendarState, customerShiftCalendarItemState, customerShiftListState, customerShiftListItemState } from "./shift.states";

const applicationsAppModule: aboTheme.INgModule = {
  components: {customerShiftComponent, customerShiftCalendarComponent},
  states: [ customerShiftState, customerShiftCalendarState, customerShiftCalendarItemState, customerShiftListState, customerShiftListItemState ],
  services: {}
};

loadNg1Module(ngmodule, applicationsAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/customerShifts/index.ts